import { Component, Input, OnInit, OnChanges } from '@angular/core';

@Component({
	selector: 'cv-photo-content-sketch',
	templateUrl: './photo-content-sketch.component.html',
	styleUrls: ['../photo-content-detail.component.scss']
})
export class PhotoContentSketchComponent implements OnInit, OnChanges {
	levels: any;
	structureType: string;
	@Input() info: any;

	/**
   * Set information for  lifecycle hooks
   */
	setInfoSketch(): void {
		const { structureType, levelInfo } = this.info;
		this.structureType = structureType;
		this.levels = levelInfo;
	}

	ngOnChanges(): void {
		if (this.info) {
			this.setInfoSketch();
		}
	}

	ngOnInit(): void {
		this.setInfoSketch();
	}
}
